const valuePropCardContentAlt = {
  displayField: 'cardHeadline',
  name: 'Value Prop Card Content ALT',
  description: '',
  fields: [
    {
      id: 'cardImage',
      name: 'Card Image',
      type: 'Link',
      localized: false,
      required: true,
      validations: [
        {linkMimetypeGroup: ['image']},
        {assetFileSize: {min: null, max: 102400}},
      ],
      disabled: false,
      omitted: false,
      linkType: 'Asset',
    },
    {
      id: 'cardHeadline',
      name: 'Card Headline',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
    },
    {
      id: 'cardSubHeadline',
      name: 'Card Sub-headline',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
    },
    {
      id: 'cardDescription',
      name: 'Card Description',
      type: 'Text',
      localized: true,
      required: true,
      validations: [
        {
          size: {
            min: 0,
            max: 400,
          },
          message:
            'Please shorten the text so its no longer than 400 characters ',
        },
      ],
      disabled: false,
      omitted: false,
    },
    {
      id: 'links',
      name: 'Links',
      type: 'Array',
      localized: false,
      required: false,
      validations: [
        {
          size: {
            max: 1,
          },
        },
      ],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [
          {
            linkContentType: ['link', 'linkDownload'],
          },
        ],
        linkType: 'Entry',
      },
    },
  ],
  sys: {
    id: 'valuePropCardContentAlt',
    version: 18,
    updatedAt: '2024-05-07T13:57:09.644Z',
  },
};
export default valuePropCardContentAlt;
